import React from 'react';
import { CheckIcon } from '@heroicons/react/20/solid';

const cx = (...a) => a.filter(Boolean).join(' ');

const StepDot = ({ num, title, status, onClick, disabled }) => {
  let dot;
  if (status === 'done') {
    dot = (
      <span className="w-7 h-7 grid place-items-center rounded-full bg-ink-strong text-brand">
        <CheckIcon className="w-3.5 h-3.5" />
      </span>
    );
  } else if (status === 'current') {
    dot = (
      <span
        className="w-7 h-7 grid place-items-center rounded-full bg-brand text-ink-strong font-extrabold text-[12px] tabular-nums"
        style={{ boxShadow: '0 0 0 4px #FFF3DB' }}
      >
        {String(num).padStart(2, '0')}
      </span>
    );
  } else {
    dot = (
      <span className="w-7 h-7 grid place-items-center rounded-full bg-white border border-line text-muted font-bold text-[12px] tabular-nums">
        {String(num).padStart(2, '0')}
      </span>
    );
  }
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cx(
        'flex items-center gap-2.5 group disabled:cursor-not-allowed transition',
        status === 'todo' ? 'opacity-90 hover:opacity-100' : ''
      )}
    >
      {dot}
      <span className="text-left hidden md:inline-block">
        <span
          className={cx(
            'block text-[12px] font-bold tracking-tight transition',
            status === 'todo' ? 'text-muted' : 'text-ink-strong'
          )}
        >
          {title}
        </span>
      </span>
    </button>
  );
};

const ProgressRail = ({ steps, currentStep, onJump }) => {
  return (
    <div className="flex items-center gap-2 md:gap-3 w-full overflow-x-auto">
      {steps.map((s, i) => {
        const num = i + 1;
        const status =
          currentStep > num ? 'done' : currentStep === num ? 'current' : 'todo';
        return (
          <React.Fragment key={num}>
            <StepDot
              num={num}
              title={s.label}
              status={status}
              onClick={() => onJump && onJump(num)}
              disabled={!onJump}
            />
            {i < steps.length - 1 && (
              <div
                className={cx(
                  'rail-segment',
                  currentStep > num
                    ? 'done'
                    : currentStep === num
                      ? 'current'
                      : ''
                )}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ProgressRail;
